import { AerialPointsDto } from '@core/api/angular';
import { patchState, signalStore, withMethods } from '@ngrx/signals';
import { addEntity, removeEntity, withEntities } from '@ngrx/signals/entities';

export const AerialPhotographyStore = signalStore(
  withEntities<AerialPointsDto>(),
  withMethods((store) => ({
    addPhotograph: (photo: AerialPointsDto) => {
      patchState(store, addEntity(photo));
    },
    removePhotograph: (id: AerialPointsDto['id']) => {
      patchState(store, removeEntity(id));
    },
  })),
);
